import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import Logo from '../images/Logo_INC_MASTER_Colour.jpg'
import { Link } from 'react-router-dom';

function Navbar() {
    const [clientWindowHeight, setClientWindowHeight] = useState("");
    const [changeBg, setChangeBg] = useState(false)
    const [activeSection, setActiveSection] = useState('');

    useEffect(() => {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    });

   const inActive = 'px-2 py-1 transition-all duration-300 ease-in-out ml-[21px] text-[#374151] font-[400] text-[16px] hover:border-[#343373] hover:border hover:rounded-[12px] hover:text-[#343373]'

    const handleScroll = () => {
      setClientWindowHeight(window.scrollY);
    };
  
    useEffect(() => {
      // Switch to solid navbar as soon as user scrolls down (blends with content sections)
      const scrollThreshold = 80;
      if (clientWindowHeight < scrollThreshold) {
        setChangeBg(true)
      }
      else {
        setChangeBg(false)
      }
    }, [clientWindowHeight])

    useEffect(() => {
      const sections = document.querySelectorAll('section');
  
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveSection(entry.target.id);
            }
          });
        },
        { threshold: 0.4 }
      );
  
      sections.forEach((section) => {
        observer.observe(section);
      });
  
      return () => {
        sections.forEach((section) => {
          observer.unobserve(section);
        });
      };
    }, []);

  return (
    <motion.div
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
      className={`w-full fixed z-40 transition-all duration-500 ease-in-out ${
        changeBg ? 'bg-white backdrop-blur-md' : 'bg-white shadow-lg'
      }`}
    >
        <div className="">
        <div>
            <div className="flex items-center justify-between px-[36px] sm:px-[86px] py-3 md:py-5">
            <Link to='/'>
              <motion.img
                src={Logo}
                width='300'
                height='300'
                className="inline-block pl-6"
                alt="logo"
                whileHover={{ scale: 1.03 }}
                transition={{ duration: 0.2 }}
              />
            </Link>
              <div className="hidden sm:flex flex-col pr-3 justify-center">
              <div className='flex'>
                <ul className='flex navlink'>
                  {[
                    { href: '#about', id: 'home', label: 'About' },
                    { href: '#service', id: 'service', label: 'Services' },
                    { href: '#review', id: 'review', label: 'Reviews' },
                    { href: '#contact', id: 'contact', label: 'Contact' },
                  ].map((item, i) => (
                    <motion.a
                      key={item.id}
                      href={item.href}
                      className={activeSection === item.id ? 'px-2 py-1 ml-[21px] transition-all duration-300 active text-[16px] border-[#343373] font-[300] border-2 rounded-[12px] text-[#343373]' : inActive}
                      initial={{ opacity: 0, y: -20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4, delay: 0.3 + i * 0.1 }}
                      whileHover={{ scale: 1.05 }}
                    >
                      {item.label}
                    </motion.a>
                  ))}
                </ul>
              </div>
              </div>
            </div>
        </div>
        </div>
    </motion.div>
  )
}

export default Navbar
